import React from 'react';
import '../styles/Skills.css';

function Skills() {
  const skillCategories = [
    {
      title: "Frontend Technologies",
      skills: [
        { name: "React", level: 90 },
        { name: "JavaScript (ES6+)", level: 85 },
        { name: "HTML5", level: 95 },
        { name: "CSS3/Sass", level: 90 },
        { name: "TypeScript", level: 80 },
        { name: "Redux", level: 75 }
      ]
    },
    {
      title: "Tools & Frameworks",
      skills: [
        { name: "Git/GitHub", level: 100 },
        { name: "Webpack", level: 70 },
        { name: "Node.js", level: 80 },
        { name: "REST APIs", level: 90 },
        { name: "Responsive Design", level: 90 },
        { name: "Testing (Jest)", level: 70 }
      ]
    },
    {
      title: "Design & Soft Skills",
      skills: [
        { name: "UI/UX Design", level: 89 },
        { name: "Problem Solving", level: 90 },
        { name: "Team Collaboration", level: 95 },
        { name: "Agile/Scrum", level: 100 },
        { name: "Communication", level: 100 },
        { name: "Time Management", level: 90 }
      ]
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2 className="section-title">Skills & Technologies</h2>
        <p className="section-subtitle">
          Here are the technologies and tools I work with
        </p>
        <div className="skills-grid">
          {skillCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="skill-category">
              <h3 className="category-title">{category.title}</h3>
              <div className="skills-list">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <div className="skill-header">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-percentage">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <div 
                        className="skill-progress"
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;